export default "__VITE_ASSET__mJBnjTvz__"